/* eslint-disable @next/next/no-img-element */

import { useImageLoadingStatus, useTimeout } from "@imwebme/clay-hooks";
import { useState } from "react";
import { Skeleton } from "../../Skeleton";
import { SwitchCase } from "../../hocs";
import type { SafeImageLoadingProps } from "./SafeImageLoading.types";

export const SafeImageLoading = ({
  src,
  fallback = null,
  width = "100%",
  height = "100%",
  loadingDelay = 0,
}: SafeImageLoadingProps) => {
  const loadingStatus = useImageLoadingStatus(src);
  const [isLocalLoading, setIsLocalLoading] = useState(true);

  useTimeout({
    effect: () => setIsLocalLoading(false),
    ms: loadingDelay,
    enabled: loadingStatus === "loaded",
  });

  return (
    <SwitchCase
      value={loadingStatus}
      caseBy={{
        loading: <Skeleton variation="diagonal" width={width} height={height} rounded="none" />,
        loaded: isLocalLoading ? (
          <Skeleton variation="diagonal" width={width} height={height} rounded="none" />
        ) : (
          <img
            src={src}
            alt=""
            style={{
              width,
              height,
              objectFit: "cover",
            }}
          />
        ),
      }}
      defaultComponent={fallback}
    />
  );
};
